// extracted by mini-css-extract-plugin
export default {"descriptionContainer":"_16zHg"};